import React, {useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'
import ConnectCallModal from './components/ConnectCallModal'
import {useConsumerWidget} from './context/ConsumerWidgetContext'
import {useAuth} from './modules/auth'

const ConsumerWidgetContent: React.FC = () => {
  // Hooks
  const {currentUser} = useAuth()
  const {setPlaceCall} = useConsumerWidget()

  // States
  const [modalVisible, setModalVisible] = useState(false)
  const [amazonWidgetLoaded, setAmazonWidgetLoaded] = useState(false)

  // Check if Amazon Connect widget is loaded and hide it visually
  useEffect(() => {
    const checkWidget = () => {
      // Look for the specific Amazon Connect button class
      const amazonWidget =
        document.querySelector('[class*="acButtonStyles"]') ||
        document.querySelector('[id*="amazon_connect"]') ||
        document.querySelector('[class*="amazon-connect"]')

      if (amazonWidget && !amazonWidgetLoaded) {
        console.log('=== Amazon Connect widget detected (already hidden by CSS)')
        setAmazonWidgetLoaded(true)
      } else if (!amazonWidget && amazonWidgetLoaded) {
        console.log('=== Amazon Connect widget removed')
        setAmazonWidgetLoaded(false)
      }
    }

    // Check immediately and then periodically
    checkWidget()
    const interval = setInterval(checkWidget, 1000)

    return () => clearInterval(interval)
  }, [amazonWidgetLoaded])

  // Handle modal submission
  const handleCallSubmit = () => {
    console.log('=== Handle Call Submit')

    setModalVisible(false)
    setPlaceCall(true)
  }

  // Check if user is logged in and is a CONSUMER (after all hooks)
  const isConsumerUser = currentUser?.result?.userType === 'CONSUMER'

  // Don't render anything if user is not logged in or not a CONSUMER
  if (!currentUser || !isConsumerUser) {
    return null
  }

  return (
    <>
      {/* CSS to immediately hide Amazon Connect widget */}
      <style>
        {`
          [class*="acButtonStyles"] {
            opacity: 0 !important;
          }
        `}
      </style>

      {/* Floating Action Button - positioned to match Amazon Connect widget */}
      <div
        className='position-fixed'
        style={{
          bottom: '20px',
          right: '20px',
          zIndex: 999, // Lower than Amazon Connect widget
        }}
      >
        <Button
          variant='primary'
          size='lg'
          className='p-0 overflow-hidden border-0 rounded-circle'
          style={{
            width: 'min(55px, 10.5vh)',
            height: 'min(55px, 10.5vh)',
            boxSizing: 'border-box',
            display: 'grid',
            placeItems: 'center',
            boxShadow: '0 0 8px rgba(0, 0, 0, .3)',
            cursor: 'pointer',
            transition: 'background 0.5s ease',
            opacity: 1,
            pointerEvents: 'auto',
            lineHeight: 0,
          }}
          onClick={() => setModalVisible(true)}
          title='Call For Interpretation'
        >
          <span
            style={{
              display: 'grid',
              placeItems: 'center',
              boxSizing: 'border-box',
              width: '100%',
              height: '100%',
              minWidth: 0,
              minHeight: 0,
              padding: 'clamp(3px, 9%, 6px)',
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/media/visily-container.png`}
              alt=''
              style={{
                display: 'block',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                objectPosition: 'center',
                margin: 0,
                verticalAlign: 'middle',
              }}
            />
          </span>
        </Button>
      </div>

      {/* Connect Call Modal */}
      <ConnectCallModal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        onSubmit={handleCallSubmit}
      />
    </>
  )
}

const ConsumerWidget: React.FC = () => {
  return <ConsumerWidgetContent />
}

export default ConsumerWidget
